export default __webpack_public_path__ + "static/media/32_fish.a3e64edb.jpg";